import React from "react";
import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { to: "/", label: "Főoldal" },
  { to: "/kapcsolodas-melysegei", label: "A kapcsolódás mélységei" },
  { to: "/egy-erzes", label: "Egy érzés" },
  { to: "/milyen-terbe-erkezel", label: "Milyen térbe érkezel?" },
  { to: "/ki-vagyok-en", label: "Ki vagyok én?" },
  { to: "/misszio", label: "Misszió" },
  { to: "/szolgaltatasok", label: "Szolgáltatások" },
  { to: "/elmenyprogram", label: "Élményprogram" },
  { to: "/forras-kod-kiseres", label: "Forrás-Kód® Kísérés" },
  { to: "/visszajelzesek", label: "Visszajelzések" },
  { to: "/konzultacio", label: "Konzultáció" },
  { to: "/kapcsolat", label: "Kapcsolat" },
];

export default function PageFooter() {
  return (
    <footer
      data-testid="page-footer"
      className="bg-warm border-t border-hairline px-6 md:px-10 py-12 md:py-14"
    >
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <Link
            to="/"
            className="font-serif-display text-xl md:text-2xl text-graphite tracking-tight shrink-0 whitespace-nowrap"
          >
            Szász-Tóth <span className="text-gold italic font-normal">Enikő</span>
          </Link>

          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
            {FOOTER_LINKS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="font-body text-[11px] tracking-[0.22em] uppercase text-graphite-soft hover:text-gold transition-colors duration-300"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t border-hairline flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-[12px] text-muted-warm font-body font-light italic">
            „Minden kapcsolat hordoz valamilyen ajándékot."
          </p>
          <p className="text-[11px] tracking-[0.25em] uppercase text-muted-warm font-body">
            © {new Date().getFullYear()} — Minden jog fenntartva
          </p>
        </div>
      </div>
    </footer>
  );
}
